export default __webpack_public_path__ + "static/media/diamond-clarity-1.e5e66e12.png";